import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'ca',
  months: [
    'Gener',
    'Febrer',
    'Març',
    'Abril',
    'Maig',
    'Juny',
    'Juliol',
    'Agost',
    'Setembre',
    'Octubre',
    'Novembre',
    'Desembre',
  ],
  monthsShort: ['gen.', 'febr.', 'març', 'abr.', 'maig', 'juny', 'jul.', 'ag.', 'set.', 'oct.', 'nov.', 'des.'],
  weekdays: ['Diumenge', 'Dilluns', 'Dimarts', 'Dimecres', 'Dijous', 'Divendres', 'Dissabte'],
  weekdaysMin: ['Dg', 'Dl', 'Dt', 'Dc', 'Dj', 'Dv', 'Ds'],
  weekdaysShort: ['Dg', 'Dl', 'Dt', 'Dc', 'Dj', 'Dv', 'Ds'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D/M/YYYY',
    LL: 'D MMMM [de] YYYY',
    'LL-D': 'MMMM [de] YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM [de] YYYY, H:mm',
    'LLL-Y': 'D MMMM, H:mm',
    LLLL: 'dddd, D MMMM [de] YYYY, H:mm',
    'LLLL-Y': 'dddd D MMMM, H:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D [de] MMM [de] YYYY',
    'll-Y': 'D [de] MMM',
    'll-D': 'MMM [de] YYYY',
    lll: 'D [de] MMM [de] YYYY, h:mm A',
    'lll-Y': 'D [de] MMM, h:mm A',
    llll: 'ddd, D [de] MMM [de] YYYY, h:mm A',
    'llll-Y': 'ddd, D [de] MMM, h:mm A',
    'll-Y+w': 'ddd, D [de] MMM',
    'LT+to': 'H:mm ([GMT]Z)',
    'LLL+to': 'D MMMM [de] YYYY, H:mm ([GMT]Z)',
  },
  meridiem: { am: 'a. m.', pm: 'p. m.', AM: 'a. m.', PM: 'p. m.' },
  past: {
    y: { one: 'fa %s any', other: 'fa %s anys' },
    M: { one: 'fa %s mes', other: 'fa %s mesos' },
    w: { one: 'fa %s setm.', other: 'fa %s setm.' },
    d: { one: 'fa %s dia', other: 'fa %s dies' },
    h: { one: 'fa %s h', other: 'fa %s h' },
    m: { one: 'fa %s min', other: 'fa %s min' },
    s: { one: 'fa %s s', other: 'fa %s s' },
  },
  future: {
    y: { one: 'd’aquí a %s any', other: 'd’aquí a %s anys' },
    M: { one: 'd’aquí a %s mes', other: 'd’aquí a %s mesos' },
    w: { one: 'd’aquí a %s setm.', other: 'd’aquí a %s setm.' },
    d: { one: 'd’aquí a %s dia', other: 'd’aquí a %s dies' },
    h: { one: 'd’aquí a %s h', other: 'd’aquí a %s h' },
    m: { one: 'd’aquí a %s min', other: 'd’aquí a %s min' },
    s: { one: 'd’aquí a %s s', other: 'd’aquí a %s s' },
  },
  pastLong: {
    y: { one: 'fa %s any', other: 'fa %s anys' },
    M: { one: 'fa %s mes', other: 'fa %s mesos' },
    w: { one: 'fa %s setmana', other: 'fa %s setmanes' },
    d: { one: 'fa %s dia', other: 'fa %s dies' },
    h: { one: 'fa %s hora', other: 'fa %s hores' },
    m: { one: 'fa %s minut', other: 'fa %s minuts' },
    s: { one: 'fa %s segon', other: 'fa %s segons' },
  },
  futureLong: {
    y: { one: 'd’aquí a %s any', other: 'd’aquí a %s anys' },
    M: { one: 'd’aquí a %s mes', other: 'd’aquí a %s mesos' },
    w: { one: 'd’aquí a %s setmana', other: 'd’aquí a %s setmanes' },
    d: { one: 'd’aquí a %s dia', other: 'd’aquí a %s dies' },
    h: { one: 'd’aquí a %s hora', other: 'd’aquí a %s hores' },
    m: { one: 'd’aquí a %s minut', other: 'd’aquí a %s minuts' },
    s: { one: 'd’aquí a %s segon', other: 'd’aquí a %s segons' },
  },
  abbr: {
    y: { one: '%s any', other: '%s anys' },
    M: { one: '%s mes', other: '%s mesos' },
    w: { one: '%s set', other: '%s set' },
    d: { one: '%s d', other: '%s d' },
    h: { one: '%s h', other: '%s h' },
    m: { one: '%s min', other: '%s min' },
    s: { one: '%s s', other: '%s s' },
  },
  full: {
    y: { one: '%s any', other: '%s anys' },
    M: { one: '%s mes', other: '%s mesos' },
    w: { one: '%s setmana', other: '%s setmanes' },
    d: { one: '%s dia', other: '%s dies' },
    h: { one: '%s hora', other: '%s hores' },
    m: { one: '%s minut', other: '%s minuts' },
    s: { one: '%s segon', other: '%s segons' },
  },
  justNow: 'Ara mateix',
  yesterday: 'Ahir',
  today: 'Avui',
  tomorrow: 'Demà',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'h:mm A': 'H:mm' },
  timeRangeStyles: {
    yl: { start: 'D MMMM [de] YYYY', end: 'D MMMM [de] YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM [de] YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM [de] YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D [de] MMM [de] YYYY', end: 'D [de] MMM [de] YYYY' },
    'y-1': { start: 'D [de] MMM', end: 'D [de] MMM [de] YYYY' },
    m: { start: 'D [de] MMM', end: 'D [de] MMM' },
    'm-1': { start: 'D', end: 'D [de] MMM [de] YYYY' },
    d: { start: 'D', end: 'D [de] MMM' },
    Y: { start: 'ddd, D [de] MMM [de] YYYY', end: 'ddd, D [de] MMM [de] YYYY' },
    'Y-1': { start: 'ddd, D [de] MMM', end: 'ddd, D [de] MMM [de] YYYY' },
    M: { start: 'ddd, D [de] MMM', end: 'ddd, D [de] MMM' },
    D: { start: 'ddd, D', end: 'ddd, D [de] MMM' },
    yt: { start: 'D [de] MMM [de] YYYY, H:mm', end: 'D [de] MMM [de] YYYY, H:mm' },
    mt: { start: 'D [de] MMM, H:mm', end: 'D [de] MMM, H:mm' },
    dt: { start: 'D [de] MMM, H:mm', end: 'D [de] MMM, H:mm' },
    t: { start: 'H:mm', end: 'H:mm' },
    'yt+to': { start: 'D [de] MMM [de] YYYY, H:mm', end: 'D [de] MMM [de] YYYY, H:mm ([GMT]Z)' },
    'mt+to': { start: 'D [de] MMM, H:mm', end: 'D [de] MMM, H:mm ([GMT]Z)' },
    'dt+to': { start: 'D [de] MMM, H:mm', end: 'D [de] MMM, H:mm ([GMT]Z)' },
    't+to': { start: 'H:mm', end: 'H:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'ca';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => {
    let ord;

    if (n === 1 || n === 3) ord = 'r';
    else if (n === 2) ord = 'n';
    else if (n === 4) ord = 't';
    else ord = 'è';

    return `${n}${ord}`;
  },
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'a. m.' : 'a. m.';
    } else {
      return isLowerCase ? 'p. m.' : 'p. m.';
    }
  },
};
